/**
 * UserCenterSlotsService 实现
 *
 * 用户中心 Slot 注册服务的核心实现，负责 slot 的注册、存储、排序和订阅通知。
 */
/** 默认排序权重 */
const DEFAULT_ORDER = 100;
/**
 * 用户中心 Slot 注册服务
 *
 * 管理第三方业务 Mod 注册到用户中心的 UI 扩展槽位。
 * 支持订阅模式，页面可在 slot 增删时自动重渲染。
 */
export class UserCenterSlotsService {
    constructor() {
        /** 已注册的 slots，key 为 slot id */
        this.slots = new Map();
        /** 按 mod 注册的 slot id 映射，用于批量卸载 */
        this.modRegistry = new Map();
        /** 订阅者列表 */
        this.listeners = new Set();
    }
    registerSlot(slot) {
        // 校验 slot id 唯一性
        if (this.slots.has(slot.id)) {
            throw new Error(`[UserCenterSlots] Slot conflict: "${slot.id}" already registered by mod "${this.slots.get(slot.id).modName}"`);
        }
        // 存储 slot，自动填充 order
        const normalizedSlot = {
            ...slot,
            order: slot.order ?? DEFAULT_ORDER,
        };
        this.slots.set(slot.id, normalizedSlot);
        // 记录 mod → slot id 映射
        if (slot.modName) {
            if (!this.modRegistry.has(slot.modName)) {
                this.modRegistry.set(slot.modName, new Set());
            }
            this.modRegistry.get(slot.modName).add(slot.id);
        }
        // 通知订阅者
        this.notifyListeners();
    }
    registerSlots(slots) {
        for (const slot of slots) {
            this.registerSlot(slot);
        }
    }
    unregisterModSlots(modName) {
        const slotIds = this.modRegistry.get(modName);
        if (!slotIds)
            return;
        for (const id of slotIds) {
            this.slots.delete(id);
        }
        this.modRegistry.delete(modName);
        // 通知订阅者
        this.notifyListeners();
    }
    getSlots() {
        const allSlots = Array.from(this.slots.values());
        // 过滤不可见的 slot
        const visibleSlots = allSlots.filter(slot => slot.visible?.() ?? true);
        // 按 order 排序
        return visibleSlots.sort((a, b) => (a.order ?? DEFAULT_ORDER) - (b.order ?? DEFAULT_ORDER));
    }
    subscribe(listener) {
        this.listeners.add(listener);
        // 返回取消订阅函数
        return () => {
            this.listeners.delete(listener);
        };
    }
    /**
     * 通知所有订阅者 slot 列表发生变化
     */
    notifyListeners() {
        this.listeners.forEach(listener => listener());
    }
}
//# sourceMappingURL=user-center-slots-service.js.map